import {SelectItem} from 'primeng/api';

export abstract class BaseSearch {
    term: string;
    filteredModel: SelectItem[];

    abstract onSearch(): void;

    abstract onSelected(value): void;

    onChanged($event: SelectItem): void {
        if ($event.value) {
            this.term = '';
            this.filteredModel = [];
            this.onSelected($event.value);
        }
    }

    onFilter($event: any): void {
        if ($event.query) {
            this.term = $event.query;
            this.onSearch();
        } else {
            this.filteredModel = [];
        }
    }
}
